module.exports = __webpack_public_path__ + "static/media/paragraph_icon.b5d97fb7.svg";